module.exports = __webpack_public_path__ + "static/unity-logo-5b697a2ed035f28ca68b642d41d25089.png";